import React, { lazy } from 'react';
import { createRoot } from 'react-dom/client';
import type { ILicensePlateProps } from './license-plate';

const LicensePlate = lazy(async () => import('./license-plate'));

const el = '.fa-component--license-platé';
const DOM = document.querySelectorAll(el);

const render = function () {
    if (DOM) {
        DOM.forEach((component) => {
            const props = JSON.parse(component.getAttribute('data-props') ?? '{}') as ILicensePlateProps;

            createRoot(component).render(<LicensePlate licensePlate={props.licensePlate} />);
        });
    }
};

export default {
    render,
};
